import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { VSpecPageComponent } from './v-spec-page.component';
import { VSpecService } from '../../services/api/vspec.service';
import { DealerDetailService } from '../../services/api/dealer-detail.service';
import { SharedDataService } from '../../services/common/shared-data.service';
import { VSpecPDFService } from '../../services/api/vspec-pdf.service';

//
// Child Components
//
import { VSpecDealerOption } from './dealer-options/v-spec-dealer-options';
import { VSpecProtectionProducts } from './protection-products/v-spec-protection-products';
import { VSpecProtectionProductDetail } from './protection-product-detail/v-spec-protection-product-detail';
import { VSpecDetail } from './detail/v-spec-detail';
import { VSpecLocalSpecial } from './local-special/v-spec-local-special';
//
// Service
//
import { ddMarketplaceInventoryService } from '../../shared/service/common/dd-marketplace-inventory.service';
import { DownloadPDFResolver } from './resolvers/download-pdf.resolver';
//
// Temporarly add this service
//

const vSPecRoutes: Routes = [
  {
    path: ':vin',
    component: VSpecPageComponent,
    children: [
      { path: '', redirectTo: 'detail', pathMatch: 'full' },
      {
        path: 'detail',
        component: VSpecDetail
      },
      {
        path: 'accessories',
        component: VSpecDealerOption
      },
      {
        path: 'specials',
        component: VSpecLocalSpecial
      },
      {
        path: 'protectionproducts',
        component: VSpecProtectionProducts
      },
      {
        path: 'protectionproducts/detail',
        component: VSpecProtectionProductDetail
      }
    ]
  },
  {
    path: ':dealerCd/:vin',
    component: VSpecPageComponent,
    children: [
      { path: '', redirectTo: 'detail', pathMatch: 'full' },
      {
        path: 'detail',
        component: VSpecDetail,
        resolve: {
          data: DownloadPDFResolver
        }
      },
      {
        path: 'detail/download',
        component: VSpecDetail,
        resolve: {
          data: DownloadPDFResolver
        }
      },
      {
        path: 'detail/download/:id',
        component: VSpecDetail,
        resolve: {
          data: DownloadPDFResolver
        }
      },
      {
        path: 'accessories',
        component: VSpecDealerOption
      },
      {
        path: 'specials',
        component: VSpecLocalSpecial
      },
      {
        path: 'protectionproducts',
        component: VSpecProtectionProducts
      },
      {
        path: 'protectionproducts/detail',
        component: VSpecProtectionProductDetail
      }
    ]
  }
];



/**
 * define V SPEC routing module
 */
@NgModule({
  imports: [
    RouterModule.forChild(
      vSPecRoutes
    )
  ],
  providers: [
    //
    // SDL: Temporarly Added these first three service
    //
    VSpecService,
    DealerDetailService,
    SharedDataService,
    ddMarketplaceInventoryService,
    VSpecPDFService
  ]
})
export class VSpecRoutingModule { }
